module.exports = __webpack_public_path__ + "img/ms.5ae73b08.png";